/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback } from "react"
import { useSetRecoilState } from "recoil"
import { NativeNotificationState, nativeNotificationStateAtom } from "src/recoil/atoms/account"
import { nativeMobileSafeAreaAtom, NativeMobileSafeAreaState } from "src/recoil/atoms/nativeMobileSafeArea"
import { mobilePurchaseJustCompletedAtom } from "src/recoil/atoms/plans"
import { windowDimensions } from "src/util/windowWrapper"
import useMiniPlayerMode from "../hooks/useMiniPlayerMode"
import layoutStates from "../recoil/atoms/layout"
import { ConsoleLogger } from "../util/logger"

const logger = new ConsoleLogger()

type useNativeEventsCBProps = {}

export const useNativeEventsCB = (): useNativeEventsCBProps => {
  const { enterMiniPlayerMode, exitMiniPlayerMode } = useMiniPlayerMode()
  const setScreenSize = useSetRecoilState(layoutStates.screenSizeSelector)
  const setMobilePurchaseJustCompleted = useSetRecoilState(mobilePurchaseJustCompletedAtom)
  const setNativeNotificationState = useSetRecoilState(nativeNotificationStateAtom)
  const setNativeMobileSafeAreaState = useSetRecoilState(nativeMobileSafeAreaAtom)

  const onRedraw = useCallback(() => {
    logger.log(
      `onRedraw:: width: ${window.innerWidth} height: ${window.innerHeight} `
    )
    // Set the current height and width in screenSize state
    setScreenSize({
      width: window.innerWidth,
      height: window.innerHeight
    })
  }, [])

  const onEnterMiniPlayer = useCallback(() => {
    enterMiniPlayerMode()
  }, [])

  const onExitMiniPlayer = useCallback(() => {
    exitMiniPlayerMode()
  }, [])

  const onPurchaseCompleted = useCallback(() => {
    setMobilePurchaseJustCompleted(true)
  }, [])

  const onNativeNotificationSettingsUpdated = (arg: NativeNotificationState) => {
    console.log('onNativeNotificationSettingsUpdated:', arg)
    console.log(arg)
    setNativeNotificationState(arg)
  }

  const eventNativeSafeAreaBoundsUpdated = (arg: NativeMobileSafeAreaState) => {
    console.log('eventNativeSafeAreaBoundsUpdated:', arg)
    console.log(arg)
    setNativeMobileSafeAreaState((prev) => ({...prev, ...arg}))
    windowDimensions.setSafeArea(arg.top, arg.bottom)
  }

  return {
    onEnterMiniPlayer,
    onExitMiniPlayer,
    onRedraw,
    onPurchaseCompleted,
    onNativeNotificationSettingsUpdated,
    eventNativeSafeAreaBoundsUpdated
  }
}
